import { Box } from '@mui/material'
import useLayout from '../../../hooks/useLayout'
import { DesktopDrawer } from '../drawer/DesktopDrawer'
import { MobileDrawer } from '../drawer/MobileDrawer'
import { SidebarContent } from '../SidebarContent'
import useSections from './useSections'

const Sidebar = () => {
  const { isSidebarOpen, isMobileSidebarOpen } = useLayout()

  const isSidebarExpanded = isSidebarOpen || isMobileSidebarOpen
  const sections = useSections(isSidebarExpanded)

  return (
    <>
      <Box sx={{ display: { lg: 'none' } }}>
        <MobileDrawer>
          <SidebarContent id={'sidebar'} sections={sections} />
        </MobileDrawer>
      </Box>
      <Box sx={{ display: { xs: 'none', lg: 'block' } }}>
        <DesktopDrawer>
          <SidebarContent id={'sidebar'} sections={sections} />
        </DesktopDrawer>
      </Box>
    </>
  )
}

export default Sidebar
